import { render, staticRenderFns } from "./CooperativeDeclaration.vue?vue&type=template&id=6d80be7d"
import script from "./CooperativeDeclaration.vue?vue&type=script&lang=js"
export * from "./CooperativeDeclaration.vue?vue&type=script&lang=js"
import style0 from "./CooperativeDeclaration.vue?vue&type=style&index=0&id=6d80be7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports